module.exports = __webpack_public_path__ + "4d5f8d408b8b6e76563d41689513aaa5.svg";